import { AuthConfig } from 'angular-oauth2-oidc';

export const environment = {
  production: false,
  enableDarkMode: true,
};
export const depoConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://depo.tst.bawag.info',
  clientId: 'depo-bawag',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const depoEasyConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easybank-depo.tst.bawag.info',
  clientId: 'depo-easybank',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const depoEasyInvestConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easy-invest.tst.bawag.info/product-selection',
  clientId: 'depo-easybank',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const savingsConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://sparbox.tst.bawag.info',
  clientId: 'bawag-sparen',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const savingsEasyConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easybank-sparbox.tst.bawag.info',
  clientId: 'onboarding-sales',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const metalUpgradeEasyConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easybank-metalkarte.tst.bawag.info',
  clientId: 'easy-retail-current-accounts',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const bawagCAConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://ca.tst.bawag.info/existing/data',
  clientId: 'bawag-retail-current-accounts',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const easyCAConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easy-ca.tst.bawag.info/native-flow/existing/1',
  clientId: 'easy-retail-current-accounts',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const easyKidsConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easybank-kids.tst.bawag.info/',
  clientId: 'easy-retail-current-accounts',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const lendingConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://kredit.tst.bawag.info/native-flow/existing/start',
  clientId: 'bawag-retail-lending',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const lendingEasyConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easybank-kredit.tst.bawag.info/native-flow/existing/start',
  clientId: 'eb-retail-lending',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const sspConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://ssp.tst.bawag.info/existing',
  clientId: 'self-service-pages',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const sspEasyConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easybank-ssp.tst.bawag.info/existing',
  clientId: 'easy-self-service-pages',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const productSwitchConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://produktwechsel.tst.bawag.info',
  clientId: 'bawag-product-switch',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const productSwitchEasyConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easybank-produktwechsel.tst.bawag.info',
  clientId: 'easy-product-switch',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const sspConfigUrls = {
  amlFormUrl:
    'https://ssp.tst.bawag.info/existing/data/aml-info?formName=amlForm',
  loanConfirmationFormUrl:
    'https://ssp.tst.bawag.info/existing/data/loan-confirmation-info?formName=loanConfirmationForm',
  loanDeferralFormUrl:
    'https://ssp.tst.bawag.info/existing/data/credit-info?formName=deferralForm',
  changeDebitDateForm:
    'https://ssp.tst.bawag.info/existing/data/debit-date-info?formName=changeDebitDateForm',
  changeDebitAccountForm:
    'https://ssp.tst.bawag.info/existing/data/debit-account-info?formName=changeDebitAccountForm',
  currentAccountFormUrl:
    'https://ssp.tst.bawag.info/existing/data/credit-confrim?formName=ca-confirmation',
  debitReductionFormUrl:
    'https://ssp.tst.bawag.info/existing/data/debit-reduction?formName=debit-reduction',
  productConfirmationUrl:
    'https://ssp.tst.bawag.info/existing/data/product-confirmation?formName=product-confirmation',
  standingOrderAbroadUrl:
    'https://ssp.tst.bawag.info/main?formName=standing-order-abroad',
  standingOrderDomesticUrl:
    'https://ssp.tst.bawag.info/main?formName=standing-order-domestic',
  directDebitMandateRevocationUrl:
    'https://ssp.tst.bawag.info/main?formName=direct-debit-mandate-revocation',
  bankTransferComplaintUrl:
    'https://ssp.tst.bawag.info/main?formName=bank-transfer-complaint',
  bankStatementOrderUrl:
    'https://ssp.tst.bawag.info/main?formName=bank-statement-order',
  accountClosingUrl: 'https://ssp.tst.bawag.info/main?formName=account-closing',
  reimbursementFeesInterestUrl:
    'https://ssp.tst.bawag.info/main?formName=reimbursement-fees-interest',
  otherGiroUrl: 'https://ssp.tst.bawag.info/main?formName=other-giro',
  changeReferenceAccountUrl:
    'https://ssp.tst.bawag.info/main?formName=change-reference-account',
  reorderCreditCardStatementUrl:
    'https://ssp.tst.bawag.info/main?formName=reorder-credit-card-statement',
  orderAdditionalCreditCardUrl:
    'https://ssp.tst.bawag.info/main?formName=order-additional-credit-card',
  creditCardCancellationUrl:
    'https://ssp.tst.bawag.info/main?formName=credit-card-cancellation',
  creditCardChangeLimitUrl:
    'https://ssp.tst.bawag.info/main?formName=credit-card-change-limit',
  creditCardPaymentRefundUrl:
    'https://ssp.tst.bawag.info/main?formName=credit-card-payment-refund',
  creditCardPartialPaymentUrl:
    'https://ssp.tst.bawag.info/main?formName=credit-card-partial-payment',
  otherCreditCardUrl:
    'https://ssp.tst.bawag.info/main?formName=other-credit-card',
  bankStatementOrderSavingsUrl:
    'https://ssp.tst.bawag.info/main?formName=bank-statement-order-savings',
  reimbursementFeesInterestSavingsUrl:
    'https://ssp.tst.bawag.info/main?formName=reimbursement-fees-interest-savings',
  bankTransferComplaintSavingsUrl:
    'https://ssp.tst.bawag.info/main?formName=bank-transfer-complaint-savings',
  accountClosingSavingsUrl:
    'https://ssp.tst.bawag.info/main?formName=account-closing-savings',
  otherSavingsAccountUrl:
    'https://ssp.tst.bawag.info/main?formName=other-savings-account',
  savingsComplaintUrl:
    'https://ssp.tst.bawag.info/main?formName=savings-complaint',
  otherSavingsBookUrl:
    'https://ssp.tst.bawag.info/main?formName=other-savings-book',
  loanRepaymentUrl: 'https://ssp.tst.bawag.info/main?formName=loan-repayment',
  loanCorrectiveBookingUrl:
    'https://ssp.tst.bawag.info/main?formName=loan-corrective-booking',
  loanWithdrawalUrl: 'https://ssp.tst.bawag.info/main?formName=loan-withdrawal',
  otherLoanUrl: 'https://ssp.tst.bawag.info/main?formName=other-loan',
  mortgageCorrectiveBookingUrl:
    'https://ssp.tst.bawag.info/main?formName=mortgage-corrective-booking',
  changeDebitAccountMortgageUrl:
    'https://ssp.tst.bawag.info/main?formName=change-debit-account-mortgage',
  loanDisbursementConstructionFinancingUrl:
    'https://ssp.tst.bawag.info/main?formName=loan-disbursement-construction-financing',
  loanConfirmationMortgageUrl:
    'https://ssp.tst.bawag.info/main?formName=loan-confirmation-mortgage',
  changeDebitDateMortgageUrl:
    'https://ssp.tst.bawag.info/main?formName=change-debit-date-mortgage',
  loanWithdrawalMortgageUrl:
    'https://ssp.tst.bawag.info/main?formName=loan-withdrawal-mortgage',
  loanDeferralMortgageUrl:
    'https://ssp.tst.bawag.info/main?formName=loan-deferral-mortgage',
  loanRepaymentMortgageUrl:
    'https://ssp.tst.bawag.info/main?formName=loan-repayment-mortgage',
  otherMortgageUrl: 'https://ssp.tst.bawag.info/main?formName=other-mortgage',
  fraudReportUrl: 'https://ssp.tst.bawag.info/main?formName=fraud-report',
  transactionDisputeUrl:
    'https://ssp.tst.bawag.info/main?formName=transaction-dispute',
  fraudReportCaUrl: 'https://ssp.tst.bawag.info/main?formName=fraud-report-ca',
  transactionDisputeCaUrl:
    'https://ssp.tst.bawag.info/main?formName=transaction-dispute-ca',
  fraudReportCreditCardUrl:
    'https://ssp.tst.bawag.info/main?formName=fraud-report-credit-card',
  transactionDisputeCreditCardUrl:
    'https://ssp.tst.bawag.info/main?formName=transaction-dispute-credit-card',
  contactChangeUrl: 'https://ssp.tst.bawag.info/main?formName=contact-change',
  chatbotTicketUrl: 'https://ssp.tst.bawag.info/chatbot-ticket',
  securedIdUpdateUrl: 'https://ssp.tst.bawag.info/main/secured-id-update',
  securedRpUpdateUrl: 'https://ssp.tst.bawag.info/main/secured-rp-update',
  cashlessPaymentUrl: 'https://ssp.tst.bawag.info/simple-forms/cashless-payment',
  cashlessPensionPaymentUrl: 'https://ssp.tst.bawag.info/simple-forms/cashless-pension-payment',
  cashlessSalaryPaymentUrl: 'https://ssp.tst.bawag.info/simple-forms/cashless-salary-payment',
  personalDataChangeUrl:
    'https://ssp.tst.bawag.info/customer/data/personal-data-change?formName=personal-data-change',
  disTicketStatusUrl: 'https://ssp.tst.bawag.info/ticket-status-check',
};

export const sspEasyConfigUrls = {
  amlFormUrl:
    'https://easybank-ssp.tst.bawag.info/existing/data/aml-info?formName=amlForm',
  loanConfirmationFormUrl:
    'https://easybank-ssp.tst.bawag.info/existing/data/loan-confirmation-info?formName=loanConfirmationForm',
  loanDeferralFormUrl:
    'https://easybank-ssp.tst.bawag.info/existing/data/credit-info?formName=deferralForm',
  changeDebitDateForm:
    'https://easybank-ssp.tst.bawag.info/existing/data/debit-date-info?formName=changeDebitDateForm',
  changeDebitAccountForm:
    'https://easybank-ssp.tst.bawag.info/existing/data/debit-account-info?formName=changeDebitAccountForm',
  currentAccountFormUrl:
    'https://easybank-ssp.tst.bawag.info/existing/data/credit-confrim?formName=ca-confirmation',
  debitReductionFormUrl:
    'https://easybank-ssp.tst.bawag.info/existing/data/debit-reduction?formName=debit-reduction',
  productConfirmationUrl:
    'https://easybank-ssp.tst.bawag.info/existing/data/product-confirmation?formName=product-confirmation',
  standingOrderAbroadUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=standing-order-abroad',
  standingOrderDomesticUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=standing-order-domestic',
  directDebitMandateRevocationUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=direct-debit-mandate-revocation',
  bankTransferComplaintUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=bank-transfer-complaint',
  bankStatementOrderUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=bank-statement-order',
  accountClosingUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=account-closing',
  reimbursementFeesInterestUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=reimbursement-fees-interest',
  otherGiroUrl: 'https://easybank-ssp.tst.bawag.info/main?formName=other-giro',
  changeReferenceAccountUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=change-reference-account',
  reorderCreditCardStatementUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=reorder-credit-card-statement',
  orderAdditionalCreditCardUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=order-additional-credit-card',
  creditCardCancellationUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=credit-card-cancellation',
  creditCardChangeLimitUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=credit-card-change-limit',
  creditCardPaymentRefundUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=credit-card-payment-refund',
  creditCardPartialPaymentUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=credit-card-partial-payment',
  otherCreditCardUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=other-credit-card',
  bankStatementOrderSavingsUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=bank-statement-order-savings',
  reimbursementFeesInterestSavingsUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=reimbursement-fees-interest-savings',
  bankTransferComplaintSavingsUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=bank-transfer-complaint-savings',
  accountClosingSavingsUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=account-closing-savings',
  otherSavingsAccountUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=other-savings-account',
  savingsComplaintUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=savings-complaint',
  otherSavingsBookUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=other-savings-book',
  loanRepaymentUrl: 'https://easybank-ssp.tst.bawag.info/main?formName=loan-repayment',
  loanCorrectiveBookingUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=loan-corrective-booking',
  loanWithdrawalUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=loan-withdrawal',
  otherLoanUrl: 'https://easybank-ssp.tst.bawag.info/main?formName=other-loan',
  mortgageCorrectiveBookingUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=mortgage-corrective-booking',
  changeDebitAccountMortgageUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=change-debit-account-mortgage',
  loanDisbursementConstructionFinancingUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=loan-disbursement-construction-financing',
  loanConfirmationMortgageUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=loan-confirmation-mortgage',
  changeDebitDateMortgageUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=change-debit-date-mortgage',
  loanWithdrawalMortgageUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=loan-withdrawal-mortgage',
  loanDeferralMortgageUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=loan-deferral-mortgage',
  loanRepaymentMortgageUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=loan-repayment-mortgage',
  otherMortgageUrl: 'https://easybank-ssp.tst.bawag.info/main?formName=other-mortgage',
  fraudReportUrl: 'https://easybank-ssp.tst.bawag.info/main?formName=fraud-report',
  transactionDisputeUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=transaction-dispute',
  fraudReportCaUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=fraud-report-ca',
  transactionDisputeCaUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=transaction-dispute-ca',
  fraudReportCreditCardUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=fraud-report-credit-card',
  transactionDisputeCreditCardUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=transaction-dispute-credit-card',
  contactChangeUrl:
    'https://easybank-ssp.tst.bawag.info/main?formName=contact-change',
  chatbotTicketUrl: 'https://easybank-ssp.tst.bawag.info/chatbot-ticket',
  securedIdUpdateUrl: 'https://easybank-ssp.tst.bawag.info/main/secured-id-update',
  securedRpUpdateUrl: 'https://easybank-ssp.tst.bawag.info/main/secured-rp-update',
  cashlessPaymentUrl: 'https://easybank-ssp.tst.bawag.info/simple-forms/cashless-payment',
  cashlessPensionPaymentUrl: 'https://easybank-ssp.tst.bawag.info/simple-forms/cashless-pension-payment',
  cashlessSalaryPaymentUrl: 'https://easybank-ssp.tst.bawag.info/simple-forms/cashless-salary-payment',
  secondOwnerInviteUrl: 'https://easybank-ssp.tst.bawag.info/simple-forms/joint',
  personalDataChangeUrl:
    'https://easybank-ssp.tst.bawag.info/customer/data/personal-data-change?formName=personal-data-change',
  disTicketStatusUrl: 'https://easybank-ssp.tst.bawag.info/ticket-status-check',
};

export const cardsConfig = {
  redirectUri: 'https://ftl-karte.tst.bawag.info/#/login',
};

export const cardsEasyConfig = {
  redirectUri: 'https://easybank-ftl-karte.tst.bawag.info/#/login',
};

export const ftlConfig = {
  redirectUri: 'https://ftl-kredit.tst.bawag.info/#/login',
};

export const ftlEasyConfig = {
  redirectUri: 'https://easybank-ftl-kredit.tst.bawag.info/#/login',
};

export const WrappedCampaignConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://wrapped.tst.bawag.info',
  clientId: 'depo-bawag',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const WrappedCampaignConfigEasy: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easybank-wrapped.tst.bawag.info',
  clientId: 'depo-easybank',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const DigitalCampaignConfig: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://banking-insights.tst.bawag.info/consent',
  clientId: 'depo-bawag',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const DigitalCampaignConfigEasy: AuthConfig = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easybank-banking-insights.tst.bawag.info/consent',
  clientId: 'depo-easybank',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const ftlConfigV2 = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://ftl-kredit.tst.bawag.info/?klarFlow=true',
  clientId: 'bawag-ftl-online',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const ftlEasyConfigV2 = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easybank-ftl-kredit.tst.bawag.info/?klarFlow=true',
  clientId: 'easy-ftl-online',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const cardsConfigV2 = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://ftl-karte.tst.bawag.info/cards?klarFlow=true',
  clientId: 'bawag-ftl-online',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const cardsEasyConfigV2 = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easybank-ftl-karte.tst.bawag.info/cards?klarFlow=true',
  clientId: 'easy-ftl-online',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};

export const jointAccountEasyConfigV2 = {
  issuer: 'https://login.tst.bawaggroup.com/auth/realms/bawaggroup',
  redirectUri: 'https://easybank-joint-account.craftsmen.tst.libra.bawag.com',
  clientId: 'generic-easybank-pages',
  scope: 'openid',
  responseType: 'code',
  showDebugInformation: true,
};
